import { CreateUserPayload } from 'modules/roles-manager/domain/resources/role-users';
import { useCreateRoleUserMutation } from 'modules/roles-manager/store';
import { useUsersPagesCache } from 'modules/roles-manager/ui/hooks/use-roles-manager-provider';
import { useCallback } from 'react';

/** Создать пользователя организации; кэш страниц обновляет сам endpoint, счётчик страниц сбрасывается здесь. */
export function useCreateUser(tournamentId?: number) {
  const [trigger, { isLoading }] = useCreateRoleUserMutation();
  const { resetPagesCache } = useUsersPagesCache();

  const createUser = useCallback(
    async (payload: CreateUserPayload) => {
      if (!tournamentId) throw new Error('No tournamentId');
      const created = await trigger({ organizerId: tournamentId, payload }).unwrap();
      resetPagesCache();
      return created;
    },
    [resetPagesCache, tournamentId, trigger],
  );

  return { createUser, isLoading };
}

export default useCreateUser;
